import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/SmallHeaderBackButton/smallHeaderBackButton.container"
    ).then((module) => ({
        default: module.SmallHeaderBackButton
    }))
);
